import {
  EnumInfoDelegaTipo,
  RichiestaModuloDTOPermessiItem,
} from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import { Space, Tooltip } from 'antd';
import clx from 'classnames';
import { lighten } from 'polished';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';
import { getDelegationTypeIcon } from './DelegationTypeUserTag';

const ActorPermissionWrapperSpace = styled(Space)`
  gap: 4px;
  /* ${down('md')} {
  } */
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  height: 32px;
  width: 32px;
  background-color: ${props => lighten(0.47, props.theme.moduleDelegateColor)};
  background-color: rgba(255, 255, 255, 0.86);

  .anticon {
    font-size: 18px;
  }
  // responsive
  ${down('md')} {
    height: 24px;
    width: 24px;
    .anticon {
      font-size: 16px;
    }
  }

  // colori
  color: ${props => props.theme.colorTextTertiary};
  &.active {
    /* opacity: 1; */
    &.sign {
      color: ${props => props.theme.purple6};
    }
    &.view {
      color: ${props => props.theme.green6};
    }
    &.compile {
      color: ${props => props.theme.blue6};
    }
  }
`;

export interface IActorPermissionIconsProps {
  permission?: RichiestaModuloDTOPermessiItem[] | null | undefined;
  isSignable: boolean | undefined;
}

/**
 * Tag di un utente delegato
 */
export function ActorPermissionIcons(props: IActorPermissionIconsProps) {
  const { permission, isSignable } = props;
  const { t } = useTranslation();

  const AllowedText = t('actor-permission-icons.can', 'Puoi');
  const DeniedText = t('actor-permission-icons.cannot', 'Non puoi');

  const canCompile = permission?.includes(
    RichiestaModuloDTOPermessiItem.COMPILAZIONE,
  );
  const canSign = permission?.includes(RichiestaModuloDTOPermessiItem.FIRMA);
  const canView =
    permission?.includes(RichiestaModuloDTOPermessiItem.VISUALIZZAZIONE) ??
    true;

  return (
    <ActorPermissionWrapperSpace>
      {canView && (
        <Tooltip
          title={t(
            'actor-permission-icons.permesso-visualizzazione-modulo',
            '{{canView}} visualizzare il modulo.',
            {
              canView: canView ? AllowedText : DeniedText,
            },
          )}
        >
          <IconWrapper className={clx('view', { active: canView })}>
            {getDelegationTypeIcon(EnumInfoDelegaTipo.VISUALIZZAZIONE)}
          </IconWrapper>
        </Tooltip>
      )}
      {canCompile && (
        <Tooltip
          title={t(
            'actor-permission-icons.permesso-compilare-modulo',
            `{{canCompile}} compilare il modulo.`,
            {
              canCompile: canCompile ? AllowedText : DeniedText,
            },
          )}
        >
          <IconWrapper className={clx('compile', { active: canCompile })}>
            {getDelegationTypeIcon(EnumInfoDelegaTipo.COMPILAZIONE)}
          </IconWrapper>
        </Tooltip>
      )}
      {isSignable && canSign && (
        <Tooltip
          title={t(
            'actor-permission-icon.permesso-firmare-modulo',
            `{{canSign}} firmare il modulo.`,
            {
              canSign: canSign ? AllowedText : DeniedText,
            },
          )}
        >
          <IconWrapper className={clx('sign', { active: canSign })}>
            {getDelegationTypeIcon(EnumInfoDelegaTipo.FIRMA)}
          </IconWrapper>
        </Tooltip>
      )}
    </ActorPermissionWrapperSpace>
  );
}
